module.exports = __webpack_public_path__ + "media/images/lb/440-1be0e4a53b7b64bd5553734824537f36.svg";